/* Always loaded */
const basicImagesData = [
	'icons/icon-loading.svg',
	'icons/icon-loading-white.svg',
	'icons/icon-language.svg',
	'icons/icon-logout.svg',
	'icons/icon-logout-2.svg',
	'languages/da.svg',
	'languages/en.svg',
	'logo-cgl.svg',
	'logo-vikarland.svg',
	'splash.svg'
];

/* Loaded if logged in as player */
const basicGameImagesData = [
	'blackboard.svg',
	'bird.svg',

	'backgrounds/home.webp',
	'backgrounds/outside-animation-return.svg',
	'backgrounds/outside-animation.svg',
	'backgrounds/playgound-issues.webp',
	'backgrounds/school-2c-issues.svg',
	'backgrounds/school-3c-lunch.svg',
	'backgrounds/school-3c.svg',
	'backgrounds/school-8a-issues.svg',
	'backgrounds/school-8a-phones.svg',
	'backgrounds/school-8a.svg',
	'backgrounds/school-hall-kids.svg',
	'backgrounds/school-teachers-room-people.svg',
	'backgrounds/school.webp',
	'backgrounds/schoolyard-backdrop.svg',
	'backgrounds/schoolyard-foreground.webp',
	

	'characters/angry-student.svg',
	'characters/cleaning-lady.svg',
	'characters/manager.svg',
	'characters/secretary.svg',
	'characters/substitute.svg',
	'characters/test.svg',

	'icons/icon-arrow-down.svg',
	'icons/icon-arrow-right.svg',
	'icons/icon-audio-pause-blue.svg',
	'icons/icon-audio-pause.svg',
	'icons/icon-audio-play-blue.svg',
	'icons/icon-audio-play.svg',
	'icons/icon-checkmark.svg',
	'icons/icon-choose.svg',
	'icons/icon-correct.svg',
	'icons/icon-drag.svg',
	'icons/icon-flip-to-landscape.svg',
	'icons/icon-home.svg',
	'icons/icon-lock.svg',
	'icons/icon-next.svg',
	'icons/icon-star-filled.svg',
	'icons/icon-star.svg',
	'icons/icon-wrong.svg'
];

const imagesData = {
	'basic': basicImagesData,
	'basic-game': basicGameImagesData,
	'module-s1-m1': require('data/images/s1-m1').moduleImages,
	'module-s1-m2': require('data/images/s1-m2').moduleImages
};

export {
	imagesData
};
